import { Select } from '@mantine/core';
import type { IngestcfgData } from '@/lib/types/Ingest';

interface IngestcfgSelectorProps {
  ingestcfgs: IngestcfgData[];
  selectedIngestcfgId: number | null;
  onSelect: (id: number) => void;
  hasMultiple: boolean;
  isRestricted: boolean;
}

export function IngestcfgSelector({
  ingestcfgs,
  selectedIngestcfgId,
  onSelect,
  hasMultiple,
  isRestricted,
}: IngestcfgSelectorProps) {
  // Hide completely when there's only one config and user isn't restricted
  if (!hasMultiple && !isRestricted) return null;

  const options = ingestcfgs.map((cfg) => ({
    value: String(cfg.ingestcfgId),
    label: cfg.label,
  }));

  return (
    <Select
      label="Upload Profile"
      data={options}
      value={selectedIngestcfgId != null ? String(selectedIngestcfgId) : null}
      onChange={(value) => value && onSelect(parseInt(value, 10))}
      disabled={isRestricted}
      size="sm"
    />
  );
}
